import React, { useEffect, useState } from 'react';
import { Select, Form, Button, Row, Col } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody = ({close, handleSubmit, restaurant, update}) => {
    console.log(restaurant);
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [verified, setVerified] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if(!restaurant) return;

        setName(restaurant.Name);
        setAddress(restaurant.Address);
        setLat(restaurant.Lat);
        setLng(restaurant.Lng);
        setVerified(restaurant.Review == 0? false: true);

        form.setFieldsValue({
            name: restaurant.Name,
            address: restaurant.Address,
            lat: restaurant.Lat,
            lng: restaurant.Lng,
            verified: restaurant.Review == 0? false: true
        })
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            name: name,
            adderss: address,
            lat: lat,
            lng: lng,
            verified: verified? 1: 0
        })
    }

    const handleVerifiedChange = (e) => {
        console.log("AAA_ONCHANGE", e.target.checked);
        setVerified(e.target.checked);
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="name" label="Name" 
                                rules={[
                                    {
                                        required: true,
                                        message: `Name required!`,
                                    },
                                ]}>
                            <input
                                name="name"
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="address" label="Address"
                            rules={[
                                {
                                    required: true,
                                    message: `Address is required!`,
                                },
                            ]}>
                            <input
                                name="address"
                                type="text"
                                value={address}
                                placeholder="Address"
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                                
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="lat" label="Latitude"
                            rules={[
                                {
                                    required: true,
                                    message: `Latitude is required!`,
                                },
                            ]}>
                            <input
                                name="lat"
                                type="number"
                                step="0.000001"
                                value={lat}
                                placeholder="Latitude"
                                onChange={(e) => setLat(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                                
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="lng" label="Longitude"
                            rules={[
                                {
                                    required: true,
                                    message: `Longitude is required!`,
                                },
                            ]}>
                            <input
                                name="lng"
                                type="number"
                                step="0.000001"
                                value={lng}
                                placeholder="Longitude"
                                onChange={(e) => setLng(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {restaurant && <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="verified" label="Verified">
                            <input
                                name="verified"
                                type="checkbox"
                                checked={verified}
                                placeholder="Verified"
                                onChange={(e) => handleVerifiedChange(e)}
                            />
                        </Form.Item>
                    </Col>
                </Row>}
            </div>    
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{restaurant ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;